import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantPersonalDetailsPage = {
  alert: {
    error: 'coapplicant-personal-details-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-personal-details-page.footer.root',
  },
  form: {
    emailAddressInput:
      'coapplicant-personal-details-page.form.email-address-input',
    emailAddressInputError:
      'coapplicant-personal-details-page.form.email-address-input-error',
    firstNameInput: 'coapplicant-personal-details-page.form.first-name-input',
    firstNameInputError:
      'coapplicant-personal-details-page.form.first-name-input-error',
    h1: 'coapplicant-personal-details-page.form.h1',
    h2: 'coapplicant-personal-details-page.form.h2',
    lastNameInput: 'coapplicant-personal-details-page.form.last-name-input',
    lastNameInputError:
      'coapplicant-personal-details-page.form.last-name-input-error',
    phoneInput: 'coapplicant-personal-details-page.form.phone-input',
    phoneInputError: 'coapplicant-personal-details-page.form.phone-input-error',
    root: 'coapplicant-personal-details-page.form.root',
    submitButton: 'coapplicant-personal-details-page.form.submit-button',
  },
  header: {
    drawerButton: 'coapplicant-personal-details-page.header.drawer-button',
    previousStepButton:
      'coapplicant-personal-details-page.header.previous-step-button',
    root: 'coapplicant-personal-details-page.header.root',
  },
  progress: {
    root: 'coapplicant-personal-details-page.progress.root',
  },
} as const satisfies PageLocatorMap;
